import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { FornecedorService } from 'src/app/service/fornecedor.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { Fornecedor } from './fornecedor';

@Component({
  selector: 'app-fornecedor-consulta',
  templateUrl: './fornecedor-consulta.component.html',
  styleUrls: [
    './fornecedor.component.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class FornecedorConsultaComponent {

  fornecedores: Fornecedor[] = [];
  ordemColunasTabela = ['id', 'name', 'telephone', 'address', 'block', 'batch', 'excluir', 'editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  mensagemErros: String[] = [];
  tipoFiltro = 'ID';
  tipoFiltros: string[] = ['ID', 'Fornecedor'];
  parametro = '';
  consultaRealizada = false;

  constructor(
    private fornecedorService: FornecedorService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  novo() {
    this.router.navigate(['/fornecedor/form']);
  }

  editar(id: number) {
    this.router.navigate(['/fornecedor/form', id]);
  }

  onFiltroChange() {
    this.consultaRealizada = false;
    this.fornecedores = [];
    this.totalElementos = 0;
    this.pagina = 0;
  }

  consultar(resetPagina = true) {
    if (resetPagina) {
      this.pagina = 0;
    }

    const request = this.parametro?.trim()
      ? this.fornecedorService.findFornecedores(this.pagina, this.tamanho, this.tipoFiltro, this.parametro)
      : this.fornecedorService.list(this.pagina, this.tamanho);

    request.subscribe((response) => {
      this.fornecedores = response.content;
      this.totalElementos = response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
      this.mensagemErros = [];
    }, err => {
      this.mensagemErros = ['Erro: ' + (err.error?.message ?? 'Falha ao consultar fornecedores')];
    });
  }

  paginar(event: PageEvent) {
    if (!this.consultaRealizada) {
      return;
    }
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar(false);
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.excluir(id);
      }
    });
  }

  private excluir(id: number) {
    this.fornecedorService.delete(id).subscribe(() => {
      this.mensagemErros = [];
      this.snackBar.open('Fornecedor excluído com sucesso!', 'Sucesso', { duration: 2000 });
      this.consultar(false);
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    });
  }
}
